import { type Epic, combineEpics } from 'redux-observable';
import { filter, map, mergeMap, withLatestFrom } from 'rxjs';
import { isEmpty } from 'lodash/fp';
import { request } from '@/core';
import { fetchRoleOptionsRequest } from '@/api/members';
import {
  tryFetchRoleOptions,
  fetchRoleOptions,
  setRoleOptions,
} from '../actions';
import { roleOptions as selectRoleOptions } from '../selectors';

const tryFetchRoleOptionsEpic: Epic = (action$, state$) =>
  action$.pipe(
    filter(tryFetchRoleOptions.match),
    withLatestFrom(state$),
    map(([, state]) => {
      const roleOptions = selectRoleOptions(state);

      if (isEmpty(roleOptions)) {
        return fetchRoleOptions();
      }

      return {
        type: 'ROLE_OPTIONS_ALREADY_FETCHED',
      };
    }),
  );

const fetchRoleOptionsEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchRoleOptions.match),
    request(fetchRoleOptionsRequest, fetchRoleOptions),
  );

const fetchRoleOptionsSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchRoleOptions.succeeded.match),
    mergeMap(({ payload: { data: roleOptions } }) => [
      setRoleOptions(roleOptions),
    ]),
  );

export default combineEpics(
  tryFetchRoleOptionsEpic,
  fetchRoleOptionsEpic,
  fetchRoleOptionsSucceededEpic,
);
